// actions.js
import { createAction } from "@reduxjs/toolkit";

export const fetchProductsSuccess = createAction("FETCH_PRODUCTS_SUCCESS");
export const fetchCartSuccess = createAction("FETCH_CART_SUCCESS");
export const updateCartData = (cartItems) => ({
  type: "UPDATE_CART_DATA",
  payload: cartItems,
});
